import { render } from "./IntegrationDetailsSidebar.vue?vue&type=template&id=a9cb963a"
import script from "./IntegrationDetailsSidebar.vue?vue&type=script&lang=ts"
export * from "./IntegrationDetailsSidebar.vue?vue&type=script&lang=ts"

import "./IntegrationDetailsSidebar.vue?vue&type=style&index=0&id=a9cb963a&lang=scss"
script.render = render

export default script